import { render, staticRenderFns } from "./AppFooterBar.vue?vue&type=template&id=55ee373c&scoped=true"
import script from "./AppFooterBar.vue?vue&type=script&lang=js"
export * from "./AppFooterBar.vue?vue&type=script&lang=js"
import style0 from "./AppFooterBar.vue?vue&type=style&index=0&id=55ee373c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee373c",
  null
  
)

export default component.exports